import {PlaceDTO, PlaceRank} from '@domain/place/place.dto';
import {CastleIcon, ChurchIcon, FlagIcon, LandmarkIcon, LandPlotIcon} from 'lucide-angular';
import {StringUtil} from '@shared/util/string.util';

export class PlaceUtil {

  public static readonly ICONS = {
    [PlaceRank.Town]: ChurchIcon,
    [PlaceRank.Municipality]: CastleIcon,
    [PlaceRank.District]: LandmarkIcon,
    [PlaceRank.Region]: LandPlotIcon,
    [PlaceRank.Country]: FlagIcon
  };

  public static readonly CHOICES = [
    {
      value: PlaceRank.Town,
      text: 'Town',
      icon: this.ICONS[PlaceRank.Town]
    },
    {
      value: PlaceRank.Municipality,
      text: 'Municipality',
      icon: this.ICONS[PlaceRank.Municipality]
    },
    {
      value: PlaceRank.District,
      text: 'District',
      icon: this.ICONS[PlaceRank.District]
    },
    {
      value: PlaceRank.Region,
      text: 'Region',
      icon: this.ICONS[PlaceRank.Region]
    },
    {
      value: PlaceRank.Country,
      text: 'Country',
      icon: this.ICONS[PlaceRank.Country]
    }
  ];

  public static getSlug(place: PlaceDTO | null, parent: PlaceDTO | null = null): string | null {
    if (!place?.id) {
      return null;
    }
    const data: string[] = ['loisirs à'];
    const inferredParent = parent ?? place.parent;
    if (inferredParent) {
      const parentSlug = inferredParent.translation?.name ?? inferredParent.code;
      if (parentSlug) {
        data.push(parentSlug);
      }
    }
    if (place.code) {
      data.push(place.code);
    }
    const name = place.translation?.name;
    if (name) {
      data.push(name);
    }
    let str = StringUtil.slugify(data.join(StringUtil.SLUG_SPACER)) ?? '';
    if (str.length > 0) {
      str += StringUtil.SLUG_SEPARATOR;
    }
    str += place.id;
    return str;
  }

}
